import React from 'react';
import '../styles/listPage.css';

export const LIST_PAGE_SIZE = 10;

type ListPaginationProps = {
  total: number;
  filtered: number;
  page: number;
  pages: number;
  onPageChange: (page: number) => void;
  noun: string;
  pageSize?: number;
};

export const ListPagination: React.FC<ListPaginationProps> = ({
  total,
  filtered,
  page,
  pages,
  onPageChange,
  noun,
  pageSize = LIST_PAGE_SIZE,
}) => (
  <div className="list-pagination-row">
    <span className="list-count">
      {filtered !== total
        ? `${filtered} of ${total} ${noun}`
        : `${total} ${noun}${total !== 1 ? '' : ''}`}
    </span>
    {pages > 1 && (
      <div className="list-pager">
        <button
          type="button"
          className="list-pager-btn"
          disabled={page <= 1}
          onClick={() => onPageChange(Math.max(1, page - 1))}
        >
          ←
        </button>
        <span className="list-pager-meta">{page} / {pages}</span>
        <button
          type="button"
          className="list-pager-btn"
          disabled={page >= pages}
          onClick={() => onPageChange(Math.min(pages, page + 1))}
        >
          →
        </button>
        <span className="list-pager-size">{pageSize} / page</span>
      </div>
    )}
  </div>
);

export function paginateList<T>(items: T[], page: number, pageSize = LIST_PAGE_SIZE) {
  const pages = Math.max(1, Math.ceil(items.length / pageSize));
  const safePage = Math.min(page, pages);
  const slice = items.slice((safePage - 1) * pageSize, safePage * pageSize);
  return { pages, safePage, slice };
}
